function Loader({ label = 'Chargement...' }) {
  return <p className="admin-loader">{label}</p>;
}

export default Loader;
